<template>
  <div class="crtvup-text-book-reader" :class="!showNavbar ? 'do-not-display-nav-bar' : ''">
    <!-- 征订数字教材阅读器 -->
    <xml-digital-teaching v-if="digitalTeaching" ref="xmlDigitalTeaching" :textBookData="textBookData"
      :catalogList="catalogList" :looseLeafData="looseLeafData" :bookGraphData="bookGraphData"
      :bookGraphIndexs="bookGraphIndexs" :location="location" :notesList="notesList" :bookmarkList="bookmarkList"
      :textDomList="contentList" :continueReading="false" :readOnly="false" :isTrial="isTrial"
      :isTrialIndex="isTrialIndex" :testPaperPath="testURL" @updateReadLocation="updateReadLocation" @confirm="confirm"
      @updateNotes="updateNotes" @deleteNotes="deleteNotes" @addBookmark="addBookmark" @deleteBookmark="deleteBookmark"
      @downloadFile="downloadFile" @addTextDom="addTextDom" @updateTextDom="updateTextDom"
      @deleteTextDom="deleteTextDom" :basisPath="basisPath" :pageType="pageType" :trialText="trialText"
      :trialPrompt="trialPrompt" :isOpenHyperlink="true" :isAddMark="false"
      systemEnvId="d58a0f05-b562-46fc-9516-55be91e21655" looseleafUrl="https://looseleaf-v2.ysy.crtvup.com.cn/"
      :showoQuestionBank="showoQuestionBank" :isShowAi="textBookData.showAi" @setanalysis="setanalysis"
      @openQuestionBank="openQuestionBank" @openAiParsing="openAiParsing" />

    <!-- <robot
      v-if="showRobot"
      ref="robotBox"
      :goodsId="$route.query.textBookId"
      :bookName="$route.query.bookName"
    /> -->

    <xml-robot ref="xmlRobot" :bookName="textBookData.textBooksName" :goodsId="goodsId"
      v-if="textBookData.showAi == '0' && pageType != 'pc'" />
    <robot ref="robot" :bookName="textBookData.textBooksName" :goodsId="goodsId"
      v-if="textBookData.showAi == '0' && pageType == 'pc'" />

    <el-dialog fullscreen :visible.sync="showXmlDialog" top="20px" center>
      <!-- <div @click="$router.back()" class="el-dialog-icon-arrow-left"><i class="el-icon-arrow-left"></i></div> -->
      <iframe width="100%" :height="iframeHeight" :src="iframeSrc" frameborder="0">

      </iframe>
    </el-dialog>
  </div>
</template>

<script>
import xmlRobot from "@/components/xmlRobot/xmlRobot";
import robot from "@/components/robot.vue";
import {
  getTextBookInfo,
  getTextBookCatalog,
  getTextBookLooseLeaf,
  getLeaf,
} from "@/api/looseleaf/looseleaf";
import { getCatalogInfoById } from "@/api/mobileterminalread/index";
import {
  goodsInfoDetail,
} from "@/api/bookstore/bookstore";
import { getBookGraphs } from "@/api/jiurui";

import { testURL } from "@/utils/config";
export default {
  components: { robot, xmlRobot },
  data() {
    return {
      digitalTeaching: false,
      textBookData: {},
      catalogList: [],
      looseLeafData: {},
      bookGraphData: {},
      bookGraphIndexs: [],
      trialText: "<p>该处已超出试读范围</p><p>请购买后阅读</p>",
      trialPrompt: "<p>该处已超出试读范围</p><p>请购买后阅读</p>",
      location: "",
      basisPath: "",
      notesList: [],
      bookmarkList: [],
      pageType: "pc",
      contentList: [],
      isTrial: false,
      isTrialIndex: 10,
      textBookId: "",
      isShow: "",
      showRobot: true,
      testURL: testURL,
      showNavbar: true,
      goodsId: "",
      goodsInfo: {},
      showoQuestionBank: false,
      showXmlDialog: false,
      iframeSrc: "",
    };
  },
  computed: {
    iframeHeight() {
      return window.innerHeight - 50 + "px";
    },
  },
  created() {
    let router = this.$route.query;
    let version = router.source
    if (router.textBookId) {
      this.textBookId = router.textBookId;
    }
    this.goodsId = router.goodsId || ""
    this.showNavbar = router.showNavbar == "0" ? false : true;
    if (router.pageType) {
      this.pageType = router.pageType;
    }
    if (router.isTrial) {
      this.isTrial = router.isTrial == 'true' ? true : false;
    }
    if (this.goodsId) {
      goodsInfoDetail(this.goodsId).then((response) => {
        this.goodsInfo = response.data || {};
        if (this.goodsInfo.goods?.questionBankId) {
          this.showoQuestionBank = true;
        } else {
          this.showoQuestionBank = false;
        }
      });
    }
    if (router.catalogId) {
      this.catalogId = router.catalogId;
      getCatalogInfoById({ catalogId: router.catalogId, type: version }).then((res) => {
        this.queryData(res.data);
      });
    } else if (router.businessType == "textBook") {
      console.log('kkkkkkkkkkkkk', version);

      getTextBookInfo(this.textBookId, version).then((res) => {
        this.textBookData = res.data;
        this.getGraphData();
        getTextBookCatalog(this.textBookId, "1", this.textBookData.publishVersionId || '', version).then((res) => {
          this.catalogList = res.data;
        });
        getTextBookLooseLeaf(this.textBookId, this.textBookData.publishVersionId || '', version).then((res) => {
          this.looseLeafData = JSON.parse(res.msg);
          setTimeout(() => {
            this.digitalTeaching = true;
          }, 500);
        });
        this.$emit("getbookinfo", this.textBookData);
      });

    } else if (router.businessType == "looseLeaf") {
      getLeaf(this.textBookId, version).then((res) => {
        this.textBookData = res.data;
        this.catalogList = [
          {
            children: [],
            hiddenFlag: "0",
            id: this.textBookId,
            label: res.data.looseLeafName,
            level: null,
            orderNum: 0,
            parentId: null,
            uploadFileUrl: "",
          },
        ];

        let looseLeafData = {};
        looseLeafData[this.textBookId] = res.data;

        this.looseLeafData = {
          ...looseLeafData,
        };
        setTimeout(() => {
          this.digitalTeaching = true;
        }, 500);
      });
    }

    // this.location = localStorage.getItem(this.textBookData.id);
    this.notesList = JSON.parse(localStorage.getItem("notesList")) || [];
    this.bookmarkList = JSON.parse(localStorage.getItem("bookmarkList")) || [];
    this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
    // this.location = localStorage.getItem(this.textBookId);
  },

  mounted() {
    let _this = this;
    let router = this.$route.query;

  },
  methods: {
    openQuestionBank() {
      console.log('打开题库')
      if (this.pageType == "pc") {
        const { href } = this.$router.resolve({
          path: "/bookstore/generateQuestion",
          query: {
            goodsId: this.goodsInfo.goods.questionBankId,
            resourceType: "goods",
            resource: "bookCity",
            relevanceId: this.goodsInfo.goods.questionBankId,
            bookName: this.goodsInfo.goods.questionBankName,
            showAi: true,
            minWin: "1"
          },
        });
        // window.open(href, "_blank");

        // this.iframeSrc = "/" + href;
        this.iframeSrc = href;
        this.showXmlDialog = true;
      } else {
        this.myUni.postMessage({
          data: {
            name: "openQuestionBank",
            value: {
              goodsId: this.goodsInfo.goods.questionBankId,
              resourceType: "goods",
              resource: "bookCity",
              relevanceId: this.goodsInfo.goods.questionBankId,
              bookName: this.goodsInfo.goods.questionBankName,
            },
          },
        });
      }
    },
    // 打开AI解析
    openAiParsing(data) {
      if (this.textBookData.showAi == "0" && this.pageType != "pc") {
        this.$refs.xmlRobot.show = true;
        this.$refs.xmlRobot.sendingMsg(data.text);
      } else if (this.textBookData.showAi == "0" && this.pageType == "pc") {
        this.$refs.robot.robotShwo = true;
        this.$refs.robot.sending(data.text);
      }
    },
    // 确认添加笔记
    confirm(e) {
      this.notesList.push(e);
      let list = JSON.stringify(this.notesList);
      localStorage.setItem("notesList", list);
      this.notesList = JSON.parse(localStorage.getItem("notesList")) || [];
      // 添加笔记成功后显示笔记标记
      this.$refs.xmlDigitalTeaching.addNotesSign(e.location, "notes");
    },

    // 更新笔记
    updateNotes(e) {
      this.notesList.map((item, index) => {
        if (item.notesId === e.notesId) {
          this.notesList[index].notesContent = item.notesContent;
          localStorage.setItem("notesList", JSON.stringify(this.notesList));
          this.notesList = JSON.parse(localStorage.getItem("notesList")) || [];
        }
      });
    },

    // 删除笔记
    deleteNotes(e) {
      this.notesList.map((item, index) => {
        if (item.notesId === e.notesId) {
          this.notesList.splice(index, 1);
          localStorage.setItem("notesList", JSON.stringify(this.notesList));
          this.notesList = JSON.parse(localStorage.getItem("notesList")) || [];
          // 删除笔记成功后删除笔记标记
          this.$refs.xmlDigitalTeaching.deleteNotesSign(e.location, "notes");
        }
      });
    },

    addTextDom(e) {
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
      // const index = this.contentList.findIndex((item) => item.domId == e.location)
      // if (index == -1) {
      this.contentList.push({
        id: e.id,
        contentDom: e.contentDom,
        domId: e.domId,
      });
      // } else {
      // this.contentList[index].contentDom = e.contentDom
      // }
      let list2 = JSON.stringify(this.contentList);
      localStorage.setItem("contentList", list2);
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
    },
    updateTextDom(e) {
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
      const index = this.contentList.findIndex((item) => item.domId == e.domId);
      this.contentList[index].contentDom = e.contentDom;
      let list2 = JSON.stringify(this.contentList);
      localStorage.setItem("contentList", list2);
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
    },
    deleteTextDom(e) {
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
      const index = this.contentList.findIndex((item) => item.domId == e.domId);
      this.contentList.splice(index, 1);

      let list2 = JSON.stringify(this.contentList);
      localStorage.setItem("contentList", list2);
      this.contentList = JSON.parse(localStorage.getItem("contentList")) || [];
    },

    // 添加书签
    addBookmark(e) {
      this.bookmarkList.push(e);
      let list = JSON.stringify(this.bookmarkList);
      localStorage.setItem("bookmarkList", list);
      this.bookmarkList =
        JSON.parse(localStorage.getItem("bookmarkList")) || [];
      // 添加书签成功后显示书签标记
      this.$refs.xmlDigitalTeaching.addNotesSign(e.location, "bookmark");
    },

    // 删除书签
    deleteBookmark(e) {
      this.bookmarkList.map((item, index) => {
        if (item.bookmarkId === e.bookmarkId) {
          this.bookmarkList.splice(index, 1);
          localStorage.setItem(
            "bookmarkList",
            JSON.stringify(this.bookmarkList)
          );
          this.bookmarkList =
            JSON.parse(localStorage.getItem("bookmarkList")) || [];
          // 删除书签成功后删除书签标记
          this.$refs.xmlDigitalTeaching.deleteNotesSign(e.location, "bookmark");
        }
      });
    },

    // 下载资源文件
    downloadFile(e) { },

    // 更新阅读进度
    updateReadLocation(newLocation) {
      localStorage.setItem(this.textBookData.id, newLocation);
    },
    //AI解析
    setanalysis(data) {
      console.log(data);
      // 向父vue页面发送信息
      window.parent.postMessage(
        {
          data,
        },
        "*"
      );
    },

    queryData(data) {
      let bookInfo = {};

      const getItemByChild = (list, label) => {
        for (let i = 0; i < list.length; i++) {
          this.$set(list[i], "label", list[i].catalogName);
          let it = list[i];
          bookInfo[it.id] = it;
          if (it.children) {
            getItemByChild(it.children);
          }
        }
        this.looseLeafData = bookInfo;
        if (data[0].children?.length > 0) {
          for (let i = 0; i < data[0].children.length; i++) {
            this.$set(data[0].children[i], "hiddenFlag", "1");
          }
        }
        setTimeout(() => {
          this.digitalTeaching = true;
          this.catalogList = data;
        }, 500);
      };
      getItemByChild(data);
    },
    getGraphData() {
      if (this.textBookData.courseCode) {
        getBookGraphs({
          courseCode: this.textBookData.courseCode,
        }).then((res) => {
          this.bookGraphData = res.data;
        });
      }
      // getGraphAnchorIndexList({
      //   courseCode: this.textBookData.courseCode,
      // }).then(res => {
      //   this.bookGraphIndexs = res.rows || []
      // })
    },
  },
};
</script>

<style lang="scss">
.crtvup-text-book-reader {
  .ouchn-container.preview-mode .preview-for-pc .pc-container .preview-screen-pc {
    max-width: 850px;
  }

  .ouchn-container.preview-mode .preview-container-title-pc .container-iocn-search-pc {
    top: 15px;
  }

  .xml-single-question-group-pc {
    .shop-item-img {
      img {
        width: 100%;
      }
    }
  }

  .ouchn-container .parent-group {
    padding: 16px 16px;
  }

  // .tab-title-pc {
  //   display: none;
  // }
  .xml-single-question-group-pc {
    .group-content-box {
      .stem-box {
        display: flex;

        .question-number {
          padding-right: 4px;
          line-height: 28px;
        }
      }
    }
  }
}

.do-not-display-nav-bar {
  .ouchn-container.preview-mode .preview-for-pc .pc-container .preview-screen-pc {
    max-width: 700px;
  }

  .ouchn-container .parent-group {
    padding: 16px 30px;
  }

  .preview-container-title-pc {
    display: none !important;
  }

  .pc-catalog.pc-catalog--render {
    margin-top: 0 !important;
    height: calc(100vh - 6px) !important;
  }

  .ouchn-container.preview-mode .preview-tree-box-pc.custom-catalog-tree {
    height: calc(100vh - 46px) !important;
  }

  .tab-title-pc {
    top: 0 !important;
  }

  .preview-list-counter-pc {
    margin: 0 auto 40px auto !important;
    height: calc(100vh - 46px) !important;
    padding-top: 0 !important;
  }

  .preview-list-pc {
    height: 100vh !important;
  }

  .tab-title-pc {
    display: none !important;
  }

  .add-notes-bookmarks-pc {
    display: none !important;
  }

  .tab-title-pc {
    .catalog-tab {
      display: none !important;
    }
  }

}

.tab-title-h5 {
  display: none !important;
}

.tab-title-pc {
  display: none !important;
}

.xml-reader-preview-guokai .xml-digital-teaching-pc .preview-counter-main-pc {
  position: relative;
  z-index: 101;
}
</style>
